<template>
  <Layout>
    <div class="container">
      <div class="row">
        <!-- group small box -->
        <div class="col-lg-3 col-6">
          <!-- small box -->
          <div class="small-box bg-info">
            <div class="inner">
              <h3>2</h3>
              <p>Products</p>
            </div>
            <div class="icon">
              <i class="fas fa-shopping-bag"></i>
            </div>
            <a href="#" class="small-box-footer">
              More info
              <i class="fas fa-arrow-circle-right"></i>
            </a>
          </div>
        </div>
        <!-- ./col -->
        <div class="col-lg-3 col-6">
          <!-- small box -->
          <div class="small-box bg-success">
            <div class="inner">
              <h3>
                53
                <sup style="font-size: 20px">%</sup>
              </h3>
              <p>Bounce Rate</p>
            </div>
            <div class="icon">
              <i class="far fa-chart-bar"></i>
            </div>
            <a href="#" class="small-box-footer">
              More info
              <i class="fas fa-arrow-circle-right"></i>
            </a>
          </div>
        </div>
        <!-- ./col -->
        <div class="col-lg-3 col-6">
          <!-- small box -->
          <div class="small-box bg-warning">
            <div class="inner text-white">
              <h3>44</h3>
              <p>User Registrations</p>
            </div>
            <div class="icon">
              <i class="fas fa-user-tie"></i>
            </div>
            <a href="#" class="small-box-footer text-white">
              More info
              <i class="fas fa-arrow-circle-right text-white"></i>
            </a>
          </div>
        </div>
        <!-- ./col -->
        <div class="col-lg-3 col-6">
          <!-- small box -->
          <div class="small-box bg-danger">
            <div class="inner">
              <h3>65</h3>
              <p>Clear Cache</p>
            </div>
            <div class="icon">
              <i class="fas fa-recycle"></i>
            </div>
            <a href="#" class="small-box-footer">
              More info
              <i class="fas fa-arrow-circle-right"></i>
            </a>
          </div>
        </div>
        <!-- ./col -->
        <!-- end group small box -->
      </div>
      <div class="card table-responsive">
        <div class="card-header">
          <div class="row">
            <div class="col-md-9 ">
          <h3 class="card-title">จัดการใบอนุญาต</h3>
          </div>
          <div class=" col-md-3">
          <div class="card-tools mr-2 mb-auto">
            <button type="button" class="btn btn-info mr-2 mb-1 mt-1" href="#">
              <i class="fas fa-sync"></i> IB Update
            </button>
            <button type="button" class="btn btn-success mr-2 mb-1 mt-1" href="#">
              <i class="fa fa-plus"></i> Create
            </button>
          </div>
          </div>
           </div>
        </div>

        <!-- /.card-header -->
        <div class="card-body">
          <div id="example1_wrapper" class="dataTables_wrapper dt-bootstrap4">
            <div class="row">
              <div class="col-md-10">
                <div class="dataTables_length" id="example1_length">
                  <label>
                    Show
                    <select
                      name="example1_length"
                      aria-controls="example1"
                      class="custom-select custom-select-sm form-control form-control-sm"
                    >
                      <option value="10">10</option>
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </label>
                </div>
              </div>
              <div class="col-md-2">
                <div id="example1_filter" class="dataTables_filter">
                  <label>
                    Search:
                    <input
                      type="search"
                      class="form-control form-control-sm"
                      placeholder
                      aria-controls="example1"
                    />
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <table
                  id="example1"
                  class="table table-bordered table-striped dataTable"
                  role="grid"
                  aria-describedby="example1_info"
                >
                  <thead>
                    <tr role="row">
                      <th
                        class="sorting_asc"
                        tabindex="0"
                        aria-controls="example1"
                        rowspan="1"
                        colspan="1"
                        aria-sort="ascending"
                        aria-label="Rendering engine: activate to sort column descending"
                        style="width: 253.667px;"
                      >Serial Number</th>
                      <th
                        class="sorting"
                        tabindex="0"
                        aria-controls="example1"
                        rowspan="1"
                        colspan="1"
                        aria-label="Browser: activate to sort column ascending"
                        style="width: 220px;"
                      >Email</th>
                      <th
                        class="sorting"
                        tabindex="0"
                        aria-controls="example1"
                        rowspan="1"
                        colspan="1"
                        aria-label="Platform(s): activate to sort column ascending"
                        style="width: 30px;"
                      >Type</th>
                      <th
                        class="sorting"
                        tabindex="0"
                        aria-controls="example1"
                        rowspan="1"
                        colspan="1"
                        aria-label="Engine version: activate to sort column ascending"
                        style="width: 80px;"
                      >Status</th>
                      <th
                        class="sorting"
                        tabindex="0"
                        aria-controls="example1"
                        rowspan="1"
                        colspan="1"
                        aria-label="CSS grade: activate to sort column ascending"
                        style="width: 80px;"
                      >Created Date</th>
                      <th
                        class="sorting"
                        tabindex="0"
                        aria-controls="example1"
                        rowspan="1"
                        colspan="1"
                        aria-label="CSS grade: activate to sort column ascending"
                        style="width: 50px;"
                      >Edit</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr role="row" class="odd">
                      <td class="sorting_1">Gecko</td>
                      <td>Firefox 1.0</td>
                      <td>IB</td>
                      <td>
                        <div
                          class="bootstrap-switch-null bootstrap-switch-undefined bootstrap-switch-undefined bootstrap-switch-undefined bootstrap-switch-undefined bootstrap-switch-undefined bootstrap-switch bootstrap-switch-wrapper bootstrap-switch-focused bootstrap-switch-animate"
                          style="width: 88.6666px;"
                        >
                          <div
                            class="bootstrap-switch-container"
                            style="width: 130px; margin-left: 0px;"
                          >
                            <span
                              class="bootstrap-switch-handle-on bootstrap-switch-success"
                              style="width: 43px;"
                            >Active</span>
                            <span class="bootstrap-switch-label" style="width: 43.3333px;">&nbsp;</span>
                            <span
                              class="bootstrap-switch-handle-off bootstrap-switch-danger"
                              style="width: 43px;"
                            >Block</span>
                            <input
                              type="checkbox"
                              name="my-checkbox"
                              checked
                              data-bootstrap-switch
                              data-off-color="danger"
                              data-on-color="success"
                            />
                          </div>
                        </div>
                      </td>
                      <td>A</td>
                      <td>
                        <button type="button" name="update" id class="btn btn-warning text-white">
                          <i class="far fa-edit"></i>
                        </button>
                      </td>
                    </tr>
                    <tr role="row" class="even">
                      <td class="sorting_1">Gecko</td>
                      <td>Firefox 1.5</td>
                      <td>IB</td>
                      <td>
                        <div
                          class="bootstrap-switch-null bootstrap-switch-undefined bootstrap-switch-undefined bootstrap-switch-undefined bootstrap-switch-undefined bootstrap-switch-undefined bootstrap-switch bootstrap-switch-wrapper bootstrap-switch-focused bootstrap-switch-animate"
                          style="width: 88.6666px;"
                        >
                          <div
                            class="bootstrap-switch-container"
                            style="width: 130px; margin-left: 0px;"
                          >
                            <span
                              class="bootstrap-switch-handle-on bootstrap-switch-success"
                              style="width: 43px;"
                            >Active</span>
                            <span class="bootstrap-switch-label" style="width: 43.3333px;">&nbsp;</span>
                            <span
                              class="bootstrap-switch-handle-off bootstrap-switch-danger"
                              style="width: 43px;"
                            >Block</span>
                            <input
                              type="checkbox"
                              name="my-checkbox"
                              checked
                              data-bootstrap-switch
                              data-off-color="danger"
                              data-on-color="success"
                            />
                          </div>
                        </div>
                      </td>
                      <td>A</td>
                      <td>
                        <button type="button" name="update" id class="btn btn-warning text-white">
                          <i class="far fa-edit"></i>
                        </button>
                      </td>
                    </tr>
                    <tr role="row" class="odd">
                      <td class="sorting_1">Gecko</td>
                      <td>Firefox 2.0</td>
                      <td></td>
                      <td>
                        <div
                          class="bootstrap-switch-null bootstrap-switch-undefined bootstrap-switch-undefined bootstrap-switch-undefined bootstrap-switch-undefined bootstrap-switch-undefined bootstrap-switch bootstrap-switch-wrapper bootstrap-switch-focused bootstrap-switch-animate"
                          style="width: 88.6666px;"
                        >
                          <div
                            class="bootstrap-switch-container"
                            style="width: 130px; margin-left: 0px;"
                          >
                            <span
                              class="bootstrap-switch-handle-on bootstrap-switch-success"
                              style="width: 43px;"
                            >Active</span>
                            <span class="bootstrap-switch-label" style="width: 43.3333px;">&nbsp;</span>
                            <span
                              class="bootstrap-switch-handle-off bootstrap-switch-danger"
                              style="width: 43px;"
                            >Block</span>
                            <input
                              type="checkbox"
                              name="my-checkbox"
                              checked
                              data-bootstrap-switch
                              data-off-color="danger"
                              data-on-color="success"
                            />
                          </div>
                        </div>
                      </td>
                      <td>A</td>
                      <td>
                        <button type="button" name="update" id class="btn btn-warning text-white">
                          <i class="far fa-edit"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="row">
              <div class="col-md-8">
                <div
                  class="dataTables_info"
                  id="example1_info"
                  role="status"
                  aria-live="polite"
                >Showing 1 to 10 of 57 entries</div>
              </div>
              <div class="col-md-4">
                <div class="dataTables_paginate paging_simple_numbers" id="example1_paginate">
                  <ul class="pagination">
                    <li class="paginate_button page-item previous disabled" id="example1_previous">
                      <a
                        href="#"
                        aria-controls="example1"
                        data-dt-idx="0"
                        tabindex="0"
                        class="page-link"
                      >Previous</a>
                    </li>
                    <li class="paginate_button page-item active">
                      <a
                        href="#"
                        aria-controls="example1"
                        data-dt-idx="1"
                        tabindex="0"
                        class="page-link"
                      >1</a>
                    </li>
                    <li class="paginate_button page-item">
                      <a
                        href="#"
                        aria-controls="example1"
                        data-dt-idx="2"
                        tabindex="0"
                        class="page-link"
                      >2</a>
                    </li>
                    <li class="paginate_button page-item">
                      <a
                        href="#"
                        aria-controls="example1"
                        data-dt-idx="3"
                        tabindex="0"
                        class="page-link"
                      >3</a>
                    </li>
                    <li class="paginate_button page-item">
                      <a
                        href="#"
                        aria-controls="example1"
                        data-dt-idx="4"
                        tabindex="0"
                        class="page-link"
                      >4</a>
                    </li>
                    <li class="paginate_button page-item">
                      <a
                        href="#"
                        aria-controls="example1"
                        data-dt-idx="5"
                        tabindex="0"
                        class="page-link"
                      >5</a>
                    </li>
                    <li class="paginate_button page-item">
                      <a
                        href="#"
                        aria-controls="example1"
                        data-dt-idx="6"
                        tabindex="0"
                        class="page-link"
                      >6</a>
                    </li>
                    <li class="paginate_button page-item next" id="example1_next">
                      <a
                        href="#"
                        aria-controls="example1"
                        data-dt-idx="7"
                        tabindex="0"
                        class="page-link"
                      >Next</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /.card-body -->
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "@/components/Layout";

export default {
  name: "admin-dashboard",
  components: {
    Layout
  }
};
</script>

<style scoped>
.small-box-footer {
  color: white !important;
}
</style>